import * as React from "react";

const SvgIcnMinimize = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g fill="currentColor" fillRule="evenodd">
            <path d="M11 12.5a.5.5 0 01.5.5v5a.5.5 0 01-1 0v-3.794l-4.646 4.648a.5.5 0 01-.638.057l-.07-.057a.5.5 0 010-.708L9.792 13.5H6a.5.5 0 010-1h5zM12.5 12a.5.5 0 01-.5-.5v-5a.5.5 0 011 0v3.794l4.646-4.648a.5.5 0 01.638-.057l.07.057a.5.5 0 010 .708L13.708 11H17.5a.5.5 0 010 1h-5z" />
        </g>
    </svg>
);

export default SvgIcnMinimize;
